export default __webpack_public_path__ + "static/media/333.b8a0a3d6.png";